// Moving between the boxes of a form WITHOUT the mouse.
//
// Data entry here is a hundred names in a row: the hand should never leave the
// keyboard. Tab already walks the boxes, so these helpers give Enter the same
// job (next box to the right, Shift+Enter back) and let a dialog jump straight
// to a named box.
//
// Only real data-entry boxes count: a checkbox is ticked with Space where Tab
// leaves you, and buttons are reached with Tab - neither should swallow an
// Enter meant for "next name".

export const FIELD_SELECTOR = [
  'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"])',
  'select',
  'textarea',
].join(',');

const usable = (el) => !el.disabled && !el.readOnly && el.tabIndex !== -1
  && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

// Every box of the container, in the order they are drawn.
export function formFields(container) {
  if (!container) return [];
  return Array.from(container.querySelectorAll(FIELD_SELECTOR)).filter(usable);
}

// Put the caret in the next (step 1) / previous (step -1) box after `from`.
// Returns true when something was focused, so the caller can swallow the key.
export function moveField(container, from, step) {
  const list = formFields(container);
  const i = list.indexOf(from);
  if (i < 0) return false;
  const next = list[i + step];
  if (!next) return false;
  next.focus();
  if (next.select) next.select();
  return true;
}

// The box marked data-k="<key>" (Alt+N / Alt+M / Alt+C jump to one).
export function focusKey(container, key) {
  const el = container && container.querySelector(`[data-k="${key}"]`);
  if (!el || !usable(el)) return false;
  el.focus();
  if (el.select) el.select();
  return true;
}

// A typing box - Enter inside one means "next box", not "press the button".
export const isTextBox = (el) => !!el && (el.tagName === 'INPUT' || el.tagName === 'SELECT')
  && !['checkbox', 'radio', 'button', 'submit'].includes(el.type);

// Alt+1 … Alt+9 → 1 … 9, Alt+0 → 0; anything else → null. e.code is used so it
// works on a keyboard whose Alt+digit prints a symbol.
export function altDigit(e) {
  if (!e.altKey || e.ctrlKey || e.metaKey) return null;
  const m = /^(?:Digit|Numpad)(\d)$/.exec(e.code || '');
  if (m) return Number(m[1]);
  return /^\d$/.test(e.key) ? Number(e.key) : null;
}
